import { useState, useEffect } from "react";

export function useActiveSection(ids: string[]): string {
  const [activeId, setActiveId] = useState("");

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveId(entry.target.id);
          } else {
            // Clear when leaving so no link appears active between sections
            setActiveId((prev) => (prev === entry.target.id ? "" : prev));
          }
        });
      },
      { rootMargin: "-35% 0px -65% 0px", threshold: 0 },
    );

    ids.forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, [ids]);

  return activeId;
}
